import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { EntityType, Market, Ticker } from "../../_app/types";
import { _getTickerPrice } from "../../utils/_getTickerPrice";
import {
  setStrategyMaxPrice,
  setStrategyMinPrice,
  setStrategyStartPrice,
} from "../../store/slices/strategySlice";
import { _getTickers } from "../../utils/async";
import { useParams } from "react-router-dom";
import { setMaxPrice, setMinPrice, setStartPrice } from "../../store/slices/botSlice";
import Loading from "../ui/Loading";
import { _roundDec } from "../../utils/_roundToDecimals";
import { precision } from "../../utils/_precision";
import { useApi } from "../../_hooks/use-api";
import FuturesBotCreationPage from "../../_pages/FuturesBotCreationPage/FuturesBotCreationPage";
import AutoStrategyCreationPage from "../../_pages/AutoStrategyCreationPage/AutoStrategyCreationPage";

const CreationPage = () => {
  const params = useParams<{ entity: EntityType }>();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const strategy = useSelector((state: RootState) => state.strategy);
  const bot = useSelector((state: RootState) => state.bot);
  const api = useApi();

  const [tickerPrice, setTickerPrice] = useState<number | null>(null);
  const [tickers, setTickers] = useState<Ticker[]>([]);

  async function getTickerPrice(exchange: Market, base: string, quote: string) {
    const urls: Record<string, string> = {
      BINANCE: `https://api.binance.com/api/v3/ticker/price?symbol=${base}${quote}`,
      AEVO: `https://api.aevo.xyz/markets?asset=${base}&instrument_type=PERPETUAL`,
      BYBIT: `https://api.bybit.com/v5/market/tickers?category=inverse&symbol=${base}${quote}`,
    };

    let tickerPrice = 100;

    try {
      const response: any = await _getTickerPrice(urls[exchange], "GET");
      switch (exchange) {
        case "BINANCE":
          tickerPrice = +response.price;
          break;
        case "AEVO":
          tickerPrice = +response[0].mark_price;
          break;
        case "BYBIT":
          tickerPrice = +response.result.list[0].lastPrice;
          break;
      }
    } catch (error) {
      console.error("Ошибка при получении данных с Binance:", error);
    }

    tickerPrice = +tickerPrice;
    let precisionValue = 0;

    if (params.entity === "bot") {
      precisionValue =
        precision(bot.ticker.priceStep) >= 0 && precision(bot.ticker.priceStep) <= 100
          ? precision(bot.ticker.priceStep)
          : 0;
      tickerPrice = _roundDec(tickerPrice, precisionValue);
      dispatch(setStartPrice(tickerPrice));
      dispatch(setMaxPrice(_roundDec(tickerPrice * 1.2, precisionValue)));
      dispatch(setMinPrice(_roundDec(tickerPrice * 0.8, precisionValue)));
    }

    if (params.entity === "strategy") {
      precisionValue = precision(strategy.ticker.priceStep);
      tickerPrice = _roundDec(tickerPrice, precisionValue);
      dispatch(setStrategyStartPrice(tickerPrice));
      dispatch(setStrategyMaxPrice(_roundDec(tickerPrice * 1.2, precisionValue)));
      dispatch(setStrategyMinPrice(_roundDec(tickerPrice * 0.8, precisionValue)));
    }
    setTickerPrice(+tickerPrice);
  }

  useEffect(() => {
    if (params.entity === "strategy") {
      getTickerPrice(user.activeAccount.market, strategy.base, strategy.quote);
    }
  }, [strategy.base]);

  useEffect(() => {
    if (params.entity === "bot") {
      getTickerPrice(user.activeAccount.market, bot.base, bot.quote);
    }
  }, [bot.base]);

  useEffect(() => {
    _getTickers(api, setTickers, user.activeAccount.market, dispatch);
  }, [user.activeAccount.market]);

  return (
    <>
      {tickerPrice && user.profile.accounts ? (
        (params.entity === "strategy" && (
          <AutoStrategyCreationPage
            accounts={user.profile.accounts}
            tickerPrice={tickerPrice}
            tickers={tickers}
          />
        )) ||
        (params.entity === "bot" && (
          <FuturesBotCreationPage
            accounts={user.profile.accounts}
            tickerPrice={tickerPrice}
            tickers={tickers}
          />
        ))
      ) : (
        <Loading />
      )}
    </>
  );
};

export default CreationPage;
